export const isValidLanguage = (value: string|null) => {
  if (!value) return null;
  const validLanguages = ['en', 'sv', 'fr']
  if (validLanguages.includes(value))  return value;
  return null;
}
